module.exports = __webpack_public_path__ + "static/media/chemicals.554e4b12.jpg";